import { useEffect, useState } from 'react';
import { api } from './auth';
import { PROVIDER_LAYERS } from './mapTiles';
import { LEG_COLORS } from '../pages/planning-start-stop/helpers';

let cache = null;
let pending = null;
const sessions = {};

export const loadMapSettings = (force = false) => {
  if (force) { cache = null; pending = null; }
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = api.get('/map-settings').then((r) => {
      cache = r.data.data;
      Object.assign(LEG_COLORS, cache.leg_colors || {});
      return cache;
    }).catch(() => { pending = null; return null; });
  }
  return pending;
};

export function useMapSettings() {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => { let on = true; loadMapSettings().then((c) => on && c && setCfg(c)); return () => { on = false; }; }, []);
  return cfg;
}

export const googleSession = (type) => {
  if (!sessions[type]) sessions[type] = api.get('/map-settings/google-session', { params: { type } }).then((r) => r.data.data).catch(() => { delete sessions[type]; return null; });
  return sessions[type];
};

// Ayarlardaki sağlayıcılara göre katman listesi; varsayılan katman başa alınır.
export const layersFor = (cfg) => {
  const ids = Object.keys(PROVIDER_LAYERS).filter((id) => (cfg?.providers || ['esri', 'osm']).includes(PROVIDER_LAYERS[id].provider));
  const def = cfg?.default_layer;
  return def && ids.includes(def) ? [def, ...ids.filter((i) => i !== def)] : ids;
};
